export default Object.freeze({
  BadDefaultPrinter: "BadDefaultPrinter",
  ErrorUserEmailAlreadyInUse: "ErrorUserEmailAlreadyInUse",
  CancelSubscriptionSuccessCode: "10000",
  CancelSubscriptionErrorCode: "10001",
  SubscriptionSuccessCode: "10002",
  FinishLicenceTrialCode: "10003",
  CHECKOUT_NOT_EXIST: "CHECKOUT_NOT_EXIST",
  PAGO_NOT_SUCCESS: "PAGO_NOT_SUCCESS",
  CHECKOUT_NOT_SYNC: "CHECKOUT_NOT_SYNC",
  CHECKOUT_CANCEL: "CHECKOUT_CANCEL",
  SESSION_ALREADY_CLOSE: "SESSION_ALREADY_CLOSE",
});
